<div class="row">
    <ng-container *ngFor="let request of requests">
        <div class="col-md-6 col-lg-4 col-xxl-4 col-xxxl-3 animated-col ">
            <div class="request-card ccc ccc-hover" (click)="detailsHandler(request.clientDataRequestId)" role="button">
                <div HJSuppress class="card-title text-center">
                    {{request.dictionaryClientDataRequestType.value}}
                </div>

                <div class="card-content">
                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.Address" class="l-section">
                        <div class="l-home-address">
                            <span class="l-section-title">{{'requests.clientData.details.homeAddress' | translate}}</span>
                            <span HJSuppress>{{request.addresses[0]?.country | replaceIfNull}}</span>
                            <span HJSuppress>{{request.addresses[0]?.state | replaceIfNull}}</span>
                            <span HJSuppress>{{request.addresses[0]?.city | replaceIfNull}}</span>
                            <span HJSuppress>{{request.addresses[0]?.streetName | replaceIfNull}} {{request.addresses[0]?.streetNumber | replaceIfNull}}</span>
                        </div>

                        <div *ngIf="request.addresses[1]" class="l-mailing-address">
                            <span class="l-section-title">{{'requests.clientData.details.mailingAddress' | translate}}</span>
                            <span HJSuppress>{{request.addresses[1]?.country | replaceIfNull}}</span>
                            <span HJSuppress>{{request.addresses[1]?.state | replaceIfNull}}</span>
                            <span HJSuppress>{{request.addresses[1]?.city | replaceIfNull}}</span>
                            <span HJSuppress>{{request.addresses[1]?.streetName | replaceIfNull}} {{request.addresses[1]?.streetNumber | replaceIfNull}}</span>
                        </div>
                    </span>

                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.ContactInfo" class="l-section">
                        <span class="l-section-title ">{{'requests.clientData.details.email' | translate}}</span>
                        <span class="text-ellipsis" textEllipsisToTooltip ngbTooltip="" HJSuppress>{{request.contactInformation?.email | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.details.phone' | translate}}</span>
                        <span HJSuppress>{{request.contactInformation?.phone | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.details.fax' | translate}}</span>
                        <span HJSuppress>{{request.contactInformation?.fax | replaceIfNull}}</span>
                    </span>


                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.Owner" class="l-section">
                        <span class="l-section-title">{{'requests.clientData.details.name' | translate}}</span>
                        <span HJSuppress>{{request.beneficialOwner?.name | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.details.phone' | translate}}</span>
                        <span HJSuppress>{{request.beneficialOwner?.phone | replaceIfNull}}</span>
                    </span>

                    <span HJSuppress *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.Associates" class="l-section">
                        <span *ngFor="let associate of request.associates">
                            {{associate?.name | replaceIfNull}}
                        </span>
                    </span>

                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.CompanyInfo" class="l-section">
                        <span class="l-section-title">{{'requests.clientData.details.name' | translate}}</span>
                        <span HJSuppress>{{request.companyInformation?.name | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.details.mainActivityField' | translate}}</span>
                        <span HJSuppress>{{request.companyInformation?.mainActivityField | replaceIfNull}}</span>
                    </span>

                    <span HJSuppress *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.Legal" class="l-section">
                        <span *ngFor="let legalRepresentative of request.legalRepresentatives">
                            {{legalRepresentative?.firstName | replaceIfNull}} {{legalRepresentative?.lastName | replaceIfNull}}
                        </span>
                    </span>

                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.PersonalInfo" class="l-section">
                        <span class="l-section-title">{{'requests.clientData.details.name' | translate}}</span>
                        <span HJSuppress>{{request.personalInformation?.firstName | replaceIfNull}} {{request.personalInformation?.lastName | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.details.expiryDate' | translate}}</span>
                        <span HJSuppress>{{request.personalInformation?.firstName | replaceIfNull}} {{request.personalInformation?.lastName | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.details.maritalStatus' | translate}}</span>
                        <span HJSuppress>{{request.personalInformation?.dictionaryCivilStatus?.value | replaceIfNull}}</span>
                    </span>

                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.Other" class="l-section">
                        <span class="l-section-title">{{'requests.clientData.details.observation' | translate}}</span>
                        <span HJSuppress class="l-observation">{{request?.otherObservations | replaceIfNull}}</span>
                    </span>

                    <span *ngIf="request.dictionaryClientDataRequestType.code === typesEnum.BankAccount" class="l-section">
                        <span class="l-section-title">{{'requests.clientData.newRequest.iban' | translate}}</span>
                        <span HJSuppress>{{request?.iban | replaceIfNull}}</span>

                        <span class="l-section-title">{{'requests.clientData.newRequest.bank' | translate}}</span>
                        <span HJSuppress>{{request?.bank | replaceIfNull}}</span>
                    </span>
                </div>

                <div class="card-item-date">
                    <span class="date-of-request">{{'requests.details.category.dateOfRequest' | translate}}</span>
                    <span HJSuppress class="actual-date">{{request.createdOn | localizedDate}}</span>
                </div>
                <div class="status-box align-self-center">
                    <div class="status-content">
                            <div class="status-dot" 
                            [ngClass]="request.dictionaryRequestStatus.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                                    request.dictionaryRequestStatus.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress': 
                                    request.dictionaryRequestStatus.code===dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                                    request.dictionaryRequestStatus.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                        </div>
                        <div class="status-value">{{request?.dictionaryRequestStatus.value}}</div>
                    </div>
              </div>
            </div>
        </div>
    </ng-container>
</div>
